export enum IAttachmentType {
  template = 'template',
  image = 'image',
  video = 'video',
  audio = 'audio',
  file = 'file',
  fallback = 'fallback',
  location = 'location',
}
